'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contentFeatureAthletes;

var _actionTypes = require('../../actions/action-types');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var DEFAULT_MAX_WIDGET_DISPLAY = 6;

function combineExcludedAthletes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var athletes = arguments[1];

  var excludedIds = state.excludedAthleteIds ? state.excludedAthleteIds : [];
  var newIds = [];
  athletes.forEach(function (athlete) {
    newIds.push(athlete.feedUserId.relatedId);
  });

  return [].concat(newIds, _toConsumableArray(excludedIds));
}

function contentFeatureAthletes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var showTeammates = void 0;
  var query = void 0;

  switch (action.type) {
    case _actionTypes.SUCCESS_GET_SUGGESTED_ATHLETES:
      var _action$payload = action.payload,
          suggestedAthletes = _action$payload.suggestedAthletes,
          maxScore = _action$payload.maxScore;


      return Object.assign({}, state, {
        excludedAthleteIds: combineExcludedAthletes(state, suggestedAthletes),
        maxScore: maxScore,
        isSearching: false,
        hasMoreSuggestions: suggestedAthletes.length === DEFAULT_MAX_WIDGET_DISPLAY,
        refreshSuggestedAthletes: false,
        shouldUpdateSuggestions: true,
        suggestedAthletes: suggestedAthletes
      });
    case _actionTypes.SUCCESS_MODAL_GET_SUGGESTED_ATHLETES:
      var modalSuggestedAthletes = action.payload.modalSuggestedAthletes;

      return Object.assign({}, state, {
        modalSuggestedAthletes: modalSuggestedAthletes,
        isFetchingSuggestions: false,
        shouldUpdateSuggestions: false,
        refreshSuggestedAthletes: false
      });
    case _actionTypes.SUCCESS_GET_TEAMMATES:
      var _action$payload2 = action.payload,
          teammates = _action$payload2.teammates,
          hasMoreTeammates = _action$payload2.hasMoreTeammates;

      showTeammates = action.payload.showTeammates;
      return Object.assign({}, state, {
        teammates: teammates,
        excludedAthleteIds: combineExcludedAthletes(state, teammates),
        showTeammates: showTeammates,
        hasMoreTeammates: hasMoreTeammates,
        isFetchingAthletes: false
      });
    case _actionTypes.SUCCESS_GET_SEARCH_ATHLETES:
      var _action$payload3 = action.payload,
          searchAthletes = _action$payload3.searchAthletes,
          isSearching = _action$payload3.isSearching;

      query = action.payload.query;
      return Object.assign({}, state, {
        searchAthletes: searchAthletes,
        modalSearchAthletes: searchAthletes,
        isSearching: isSearching,
        query: query
      });
    case _actionTypes.SUCCESS_MODAL_GET_SEARCH_ATHLETES:
      var modalSearchAthletes = action.payload.modalSearchAthletes;

      query = action.payload.query;
      return Object.assign({}, state, {
        modalSearchAthletes: modalSearchAthletes,
        query: query
      });
    default:
      return state;
  }
}